import React, {useEffect} from "react";
import {useHistory} from "react-router";
import {Button, Table} from "antd";
import {goPage} from "../../layout/pageDefinition";
import {useModel} from "../../../models";


const columns = [
    {
        title: '序号',
        width: 80,
        render: (text, record, index) => `${index + 1}`,
    },
    {
        title: '销售订单号',
        dataIndex: 'saleOrderCode',
        align: 'left',
    },
    {
        title: '销售类型',
        dataIndex: 'orderType',
    },
    {
        title: '状态',
        dataIndex: 'orderStatus',
    },
    {
        title: '客户名称',
        dataIndex: 'customerName',
    },
    {
        title: '销售数量',
        dataIndex: 'saleNum',
    },
    {
        title: '总金额',
        dataIndex: 'aggregateAmount',
    },
    {
        title: '优惠总金额',
        dataIndex: 'discountPrice',
    },
    {
        title: '应收金额',
        render: (text, record) => record.aggregateAmount - record.discountPrice,

    },
    {
        title: '发票类型',
        dataIndex: 'invoiceType',
    },
    {
        title: '客户编码',
        dataIndex: 'customerId',
    },
    {
        title: '联系人',
        dataIndex: 'consignee',
    },
    {
        title: '电话',
        dataIndex: 'contactPhone',
    },
    {
        title: '业务员',
        dataIndex: 'salesMan',
    },
    {
        title: '公司',
        dataIndex: 'orgId',
    },
    {
        title: '制单日期',
        dataIndex: 'createTime',
    },
    {
        title: '备注',
        dataIndex: 'saleOrderDesc',
    }
];


export default function () {
    const [
        {searchParam, documentList, documentStatistic, documentPageInfo, selectedDocument, selectedDocumentRowKeys},
        {loadDocumentList, setSelectedDocument, setSelectedDocumentRowKeys}
    ] = useModel("purchaseOrder");
    useEffect(() => {
        loadDocumentList({showMsg: false})
    }, [loadDocumentList]);
    const TableHeader = () => {
        const history = useHistory();
        const onAdd = () => {
            goPage(history, "2-1-2");
        }
        const onEdit = () => {
            goPage(history, "2-1-1");
        }
        const onImport = () => {

        }
        const onExport = () => {

        }
        const onDownloadTpl = () => {

        }
        return (
            <div style={{margin: "0 0 8px", display: "flex"}}>
                <div style={{width: "460px", paddingTop: "6px"}}>
                    <Button type="primary" onClick={onAdd}>新增</Button>
                    <Button className="margin-left-8" onClick={onEdit} disabled={!!!selectedDocument}>编辑</Button>
                    <Button className="margin-left-8" onClick={onImport}>导入</Button>
                    <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    <Button className="margin-left-8" onClick={onDownloadTpl}>下载模板</Button>

                </div>
                <div className="detail-list-statistic" style={{textAlign: "right"}}>
                    <span className="margin-left-8">毛利率：{documentStatistic.grossRate}</span>
                    <span className="margin-left-16">销售成本：{documentStatistic.totalCost}</span>
                    <span className="margin-left-16">销售收入：{documentStatistic.totalRevenue}</span>
                </div>
            </div>
        )
    }

    return (
        <>
            <TableHeader/>
            <Table
                columns={columns}
                dataSource={documentList}
                bordered
                pagination={{
                    hideOnSinglePage: true,
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: (page, pageSize) => {
                        const params = {...searchParam};
                        params.pageNum = page;
                        params.pageSize = pageSize;
                        loadDocumentList({showMsg: false, data: params});
                    },
                    total: documentPageInfo.total,
                    current: documentPageInfo.pageNum,
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedDocument && selectedDocument.key === record.key) {
                                setSelectedDocument(null);
                                setSelectedDocumentRowKeys([]);
                            } else {
                                setSelectedDocument(record);
                                setSelectedDocumentRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        setSelectedDocument(selectedRows[0])
                        setSelectedDocumentRowKeys(selectedRowKeys);
                    },
                    selectedRowKeys: selectedDocumentRowKeys
                }}
                scroll={{x: 'max-content'}}
            />
        </>
    );
}